<template>
  <div class="d-flex add-icon-box">
    <i class="UXicon-add_circle" @click="() => { addItem(item) }"></i>
  </div>
</template>

<script>
export default {
  name: 'addIcon',
  props: {
    item: Object
  },
  methods: {
    addItem (item) {
      if (item.type === 'small') {
        return
      }

      const parentId = item.id

      const itemObject = {
        name: '',
        type: '',
        id: this.$uuid.v4(),
        isOpen: true,
        isRemove: false,
        parentId: parentId,
        isRemoveBtn: true,
        isProMent: false,
        isSaveLocal: true,
        children: [],
        data: {}
      }

      if (!item.type) {
        itemObject.type = 'large'
      }

      if (item.type === 'large') {
        itemObject.type = 'medium'
      }

      if (item.type === 'medium') {
        itemObject.type = 'small'
      }

      this.$eventBus.$emit('tree-add-item', parentId, itemObject.type, itemObject)
    }
  }
}
</script>

<style scoped lang="scss">
.add-icon-box {
  display: flex;
  align-items: center;
  margin-left: 5px;
  color: #ff8c8c;
}

.add-icon {
  color: #ff8c8c;
}
</style>



// WEBPACK FOOTER //
// src/views/agent/components/addIcon.vue